import React from 'react';
import Footer from './Footer';
import gal1 from '../img/gal1.jpg';
import gal2 from '../img/gal2.jpg';
import gal3 from '../img/gal3.jpg';
import gal4 from '../img/gal4.jpg';
import gal5 from '../img/gal5.jpg';
import gal6 from '../img/gal6.jpg';
import gal7 from '../img/gal7.jpg';

const Gallery = () => {
  return (
    <>
      <div className='heading'>
          <h1>Gallery</h1>
      </div>
      <div className="gallery-container">
        <img src={gal1} alt="Gallery Image 1" className="gallery-image"/>
        <img src={gal2} alt="Gallery Image 2" className="gallery-image"/>
        <img src={gal3} alt="Gallery Image 3" className="gallery-image"/>
        <img src={gal4} alt="Gallery Image 4" className="gallery-image"/>
        <img src={gal5} alt="Gallery Image 5" className="gallery-image"/>
        <img src={gal6} alt="Gallery Image 6" className="gallery-image"/>
        <img src={gal7} alt="Gallery Image 7" className="gallery-image"/>
      </div>
      <Footer/>
    </>
  );
}

export default Gallery;
